import moment from "moment/moment";

export const intervals = {
	"MORNINGS": {
		from :moment("6:00:00", "hh:mm:ss"),
		to : moment("11:59:59", "hh:mm:ss")
	},
	"MIDDAY": {
		from : moment("12:00:00", "hh:mm:ss"),
		to : moment("16:59:59", "hh:mm:ss")
	},
	"EVENINGS": {
		from : moment("17:00:00", "hh:mm:ss"),
		to : moment("5:59:59", "hh:mm:ss")
	}
};

export const initialSpecialtiesSelected = {
	CATS: false,
	DOGS: false,
	HORSES: false,
	COWS: false,
	GOATS: false,
	SHEEP: false,
	PIGS: false,
	CHICKEN: false,
	LLAMAS: false,
	ALPACAS: false,
	BIRDS: false,
	FISH: false,
	REPTILES: false,
	BUNNIES: false,
	HAMSTERS: false,
	GUINEA_PIGS: false,
	RATS: false,
	FERRETS: false
};

export const initialDaysSelected = {
	MONDAY: false,
	TUESDAY: false,
	WEDNESDAY: false,
	THURSDAY: false,
	FRIDAY: false,
	SATURDAY: false,
	SUNDAY: false
};

export const initialDayTimesSelected = {
	MORNINGS: false,
	MIDDAY: false,
	EVENINGS : false
};
